// extracted by mini-css-extract-plugin
module.exports = {"block":"dmbc-custom-block","image":"dmbc-custom-image","btn1":"dmbc-custom-btn1","btn2":"dmbc-custom-btn2","cover":"dmbc-custom-cover","trigger":"dmbc-custom-trigger"};